/*
 * @Date: 2022-06-22 18:26:54
 * @LastEditTime: 2022-10-19 15:08:10
 * @FilePath: /activity_cfhd_gmi1661411302714/index.ts
 * @Description:
 */


// declare function jQuery( cb: Function ): any;
import { isPage } from './diyWork/config'
import { initPage, allBtn } from './diyWork/init'
import LoginService, {SingleInstanceLoginService} from './AmsAndMilo/loginService'

import { getUrlParam, TGDialogS } from './utils'
import { AmsService } from './AmsAndMilo/amsSubmit'
import milo from '@tencent/milo-web'

if (isPage == 'nq') {
  (window as any).alert = milo.miloAlert
}
const login = new SingleInstanceLoginService(isPage)
const amsService = new AmsService(allBtn)
// LoginService(isPage)
  // .checkAndLogin()
  // .then((check) => {
  //   // 加入登录后的回调函数
  //   initPage()
  //   console.log(check)
  //   if (getUrlParam('shareCode')) {
  //     TGDialogS('text3')
  //   } 
  // })

// if (getUrlParam('shareCode')) {
//   TGDialogS('text3')
// } 

const styleTmp = `
<style>
  #milo_qzone_share {
    background-color: #fff;
    }
</style>
`
$('body').after(styleTmp)
  
// debugger

